export const WEEK_HIGH_LOW = "WEEK_HIGH_LOW";
export const WEEK_HIGH_LOW_STREAM = "WEEK_HIGH_LOW_STREAM";
